import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getAmplyToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.AMPLY,
    symbol: 'AMPLY',
    addressL1: '',
    addressL2: sdks.L2.getContractAddress('AMPLY'),
    addressCronosEvm: '',
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/amply.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="AMPLY"
        {...props}
      />
    ),
  };
};
